module.exports = __webpack_public_path__ + "img/amazon.e47a9d42.png";